import {create} from 'zustand';
import {UseProfessionalCouncilOptionsStoreProps} from './types';

export const useProfessionalCouncilOptionsStore = create<UseProfessionalCouncilOptionsStoreProps>(
	set => ({
		options: [],
		setOptions: options => set({options}),
		reset: () => set({options: []}),
	}),
);
